import { STATUS_COLORS } from "constants/projectRules";

/**
 * Mã hành động phê duyệt (Approval Actions)
 */
export const APPROVAL_ACTIONS = {
  SUBMIT: "SUBMIT",
  RESUBMIT: "RESUBMIT",
  EDIT: "EDIT",
  APPROVE: "APPROVE",
  REQUEST_CHANGE: "REQUEST_CHANGE",
};

/**
 * Mã hành động thay đổi dữ liệu (Change Types) cho QĐGK và Hạng mục dự toán
 */
export const SUBCONTRACT_CHANGE_TYPES = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  STATUS_CHANGE: "STATUS_CHANGE",
  DOCUMENT_UPLOAD: "DOCUMENT_UPLOAD",
  DOCUMENT_DELETE: "DOCUMENT_DELETE",
  TEAM_ADD: "TEAM_ADD",
  TEAM_REMOVE: "TEAM_REMOVE",
  COMPLETION_UPDATE: "COMPLETION_UPDATE",
  CONVERT_TO_PARENT: "CONVERT_TO_PARENT",
  MOVE_ITEM: "MOVE_ITEM",
};

/**
 * Từ điển nhãn Tiếng Việt cho các mã hành động
 */
export const HISTORY_ACTION_LABELS = {
  // Phê duyệt
  SUBMIT: "Gửi phê duyệt",
  RESUBMIT: "Gửi lại phê duyệt",
  EDIT: "Chỉnh sửa hồ sơ",
  APPROVE: "Phê duyệt",
  REQUEST_CHANGE: "Yêu cầu chỉnh sửa",

  // Quyết định giao khoán & Dự toán
  CREATE: "Tạo mới",
  UPDATE: "Cập nhật",
  DELETE: "Xóa",
  STATUS_CHANGE: "Thay đổi trạng thái",
  DOCUMENT_UPLOAD: "Tải lên tài liệu",
  DOCUMENT_DELETE: "Xóa tài liệu",
  TEAM_ADD: "Thêm nhân sự",
  TEAM_REMOVE: "Xóa nhân sự",
  COMPLETION_UPDATE: "Cập nhật tiến độ",
  CONVERT_TO_PARENT: "Chuyển thành mục cha",
  MOVE_ITEM: "Di chuyển vị trí",
};

/**
 * Quy định màu sắc hiển thị cho các hành động dựa trên STATUS_COLORS của project
 */
export const HISTORY_ACTION_COLORS = {
  // Thành công / Phê duyệt / Tạo mới
  APPROVE: STATUS_COLORS.success,
  CREATE: STATUS_COLORS.success,

  // Chờ duyệt / Thay đổi trạng thái
  SUBMIT: STATUS_COLORS.warning,
  RESUBMIT: STATUS_COLORS.warning,
  STATUS_CHANGE: STATUS_COLORS.warning,

  // Cập nhật / Tải lên / Tiến độ
  UPDATE: STATUS_COLORS.info,
  DOCUMENT_UPLOAD: STATUS_COLORS.info,
  TEAM_ADD: STATUS_COLORS.info,
  COMPLETION_UPDATE: STATUS_COLORS.info,

  // Chỉnh sửa / Trả về / Phân cấp
  EDIT: STATUS_COLORS.purple,
  REQUEST_CHANGE: STATUS_COLORS.purple,
  CONVERT_TO_PARENT: STATUS_COLORS.purple,

  // Xóa / Hủy
  DELETE: STATUS_COLORS.danger,
  DOCUMENT_DELETE: STATUS_COLORS.danger,
  TEAM_REMOVE: STATUS_COLORS.danger,

  default: STATUS_COLORS.default,
};

/**
 * Lấy nhãn tiếng Việt cho hành động, có tính đến ngữ cảnh entityType
 */
export const getHistoryActionLabel = (actionOrChangeType, entityType = null) => {
  if (!actionOrChangeType) return "-";
  const key = String(actionOrChangeType).trim().toUpperCase();

  if (entityType) {
    const ent = String(entityType).trim().toUpperCase();
    if (ent === "DOCUMENT") {
      if (key === "CREATE" || key === "DOCUMENT_UPLOAD" || key === "UPLOAD") return "Tải lên tài liệu";
      if (key === "DELETE" || key === "DOCUMENT_DELETE") return "Xóa tài liệu";
    }
    if (ent === "TEAM") {
      if (key === "CREATE" || key === "TEAM_ADD" || key === "ADD") return "Thêm nhân sự";
      if (key === "DELETE" || key === "TEAM_REMOVE" || key === "REMOVE") return "Xóa nhân sự";
    }
    if (ent === "SUBCONTRACT") {
      if (key === "CREATE") return "Tạo mới giao khoán";
      if (key === "UPDATE") return "Cập nhật giao khoán";
    }
    if (ent === "ITEM" || ent === "SUBCONTRACT_ITEM") {
      if (key === "CREATE") return "Tạo mới hạng mục";
      if (key === "UPDATE") return "Cập nhật hạng mục";
      if (key === "DELETE") return "Xóa hạng mục";
    }
  }

  return HISTORY_ACTION_LABELS[key] || actionOrChangeType;
};

/**
 * Lấy style màu sắc cho hành động
 */
export const getHistoryActionStyle = (actionOrChangeType) => {
  if (!actionOrChangeType) return HISTORY_ACTION_COLORS.default;
  const key = String(actionOrChangeType).trim().toUpperCase();
  return HISTORY_ACTION_COLORS[key] || HISTORY_ACTION_COLORS.default;
};
